define('banner/engagement-engine-service',['require','jquery','api-access','api-access','web-urls'],function (require) {
    var $ = require('jquery');
    var userApi = require('api-access').user;
    var auth = require('api-access').auth;
    var webUrls = require('web-urls');

    var bannerTypes = {
        ADD_ORGANIZERS: 'add-organizers',
        MEETING_LOCK: 'meeting-lock',
        PRESENTER_SWAP: 'presenter-swap'
    };

    // as this feature is not critical, the request is handled separately so it can't break the rest of the application
    var createAjaxRequest = function (method, url) {
        return {
            url: url,
            type: method,
            headers: {
                Authorization: 'Bearer ' + auth.getToken()
            },
            dataType: 'json'
        };
    };

    var getBannerTypeFromUrlParams = function () {
        var urlParams = location.href;
        if (urlParams.includes('bannerType')) {
            return urlParams.substr(urlParams.indexOf('=') + 1);
        }
        return false;
    };

    var engagementEngineCall = function () {
        return new Promise(function (resolve, reject) {
            userApi.me()
                .then(function (me) {
                    var url = webUrls.get('engagementEngineUrl') +
                        '/engagement-service/account/' +
                        me.accountKey +
                        '/user/' +
                        me.key +
                        '?product=g2m&endpoint=g2m-mfe-banner';

                    var testResponse = function (contentId) {
                        return {
                            engagementMessage: {
                                contentId: contentId,
                                showContent: true
                            },
                            accountKey: me.accountKey,
                            userKey: me.key
                        };
                    };

                    // this has been implemented to be able to test the banners since the EngagementEngine does not offer a proper way to do so.
                    // add ?bannerType=<bannerType> to BaseURL to force a banner to show
                    switch (getBannerTypeFromUrlParams()) {
                        case bannerTypes.ADD_ORGANIZERS:
                            resolve(testResponse(bannerTypes.ADD_ORGANIZERS));
                            break;
                        case bannerTypes.MEETING_LOCK:
                            resolve(testResponse(bannerTypes.MEETING_LOCK));
                            break;
                        case bannerTypes.PRESENTER_SWAP:
                            resolve(testResponse(bannerTypes.PRESENTER_SWAP));
                            break;
                        default:
                            var request = $.ajax(createAjaxRequest('GET', url));

                            request.done(function (resp) {
                                var response = Object.assign({}, resp, {
                                    accountKey: me.accountKey,
                                    userKey: me.key
                                });
                                if (response.engagementMessage.showContent) {
                                    if (!sessionStorage.getItem('bannerRemoved')) {
                                        resolve(response);
                                    }
                                } else {
                                    sessionStorage.removeItem('bannerRemoved');
                                    resolve(response);
                                }
                            });

                            request.fail(function (error) {
                                reject('Call to EngagementEngine was not successful:', error);
                            });
                    }
                }).fail(function (error) {
                    reject('me call was not successful', error);
                });
        });
    };

    return function () {
        return engagementEngineCall();
    };
});

